import DashboardContext from "../../container/admin/dashboard/context/dashboardContext";
import DashboardContainer from "../../container/admin/dashboard/dashboardContainer";

const Dashboard = (): React.JSX.Element => (
  <DashboardContext>
    <DashboardContainer />
  </DashboardContext>
);

export default Dashboard;
